/** Do not cycle the palette: subscription breakdowns can contain many tiers. */
export function forecastColor(index: number): string {
  return index < 16
    ? `var(--color-admin-chart-${index + 1})`
    : `hsl(${((index - 16) * 137.508 + 25) % 360} 60% 58%)`;
}
